import { render, staticRenderFns } from "./ProtestedMatchesPopup.vue?vue&type=template&id=b0a226ac&"
import script from "./ProtestedMatchesPopup.vue?vue&type=script&lang=js&"
export * from "./ProtestedMatchesPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProtestedMatchesPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports